<template>
  <b-form-group
    :label="'上傳圖片' + (multiple ? ' ( 最多' + quantity + '張 )' : '')"
    :label-for="'imagePreview' + dynamicId"
    invalid-feedback="請上傳圖片"
    :state="state"
    :class="{ required: required, group_class }"
    class="imagePreviewGroup"
  >
    <div class="image-preview" v-if="imageUrl">
      <div class="row no-gutters" v-if="multiple">
        <div class="col-6 mb-3" v-for="(item, index) in imageUrl" :key="index">
          <b-button-close
            @click="removeImage(index)"
            v-if="!readonly"
          ></b-button-close>
          <b-img thumbnail fluid :src="getAllImgUrl(item)"></b-img>
        </div>
      </div>
      <div v-else>
        <b-button-close @click="removeImage" v-if="!readonly"></b-button-close>
        <b-img thumbnail fluid :src="getAllImgUrl(imageUrl)"></b-img>
      </div>
    </div>
    <b-form-file
      v-if="multiple ? !imageUrl || imageUrl.length < quantity : !imageUrl"
      :id="'imagePreview' + dynamicId"
      accept=".jpg, .png, .gif"
      :state="state"
      v-model="imageFile"
      placeholder="請拖曳圖片到此處或點擊選擇愈上傳圖片"
      drop-placeholder="請拖曳圖片到此處"
      :multiple="multiple"
    ></b-form-file>
  </b-form-group>
</template>

<style lang="scss" scoped>
.imagePreviewGroup ::v-deep {
  .custom-file {
    height: auto;
    &-input {
      position: absolute;
      top: 0;
      left: 0;
      &:focus {
        ~ .custom-file-label {
          box-shadow: none;
        }
      }
    }
    &-label {
      position: relative;
      width: 100%;
      text-align: center;
      border: 1px dashed #ced4da;
      padding: 70px 30px 30px;
      height: auto;
      border-radius: 0;
      color: Gray;
      margin-bottom: 0;
      white-space: initial;
      &::after {
        content: "";
        display: inline-block;
        background-image: url('data:image/svg+xml,<svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-cloud-upload" fill="Gray" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.406 1.342A5.53 5.53 0 0 1 8 0c2.69 0 4.923 2 5.166 4.579C14.758 4.804 16 6.137 16 7.773 16 9.569 14.502 11 12.687 11H10a.5.5 0 0 1 0-1h2.688C13.979 10 15 8.988 15 7.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 2.825 10.328 1 8 1a4.53 4.53 0 0 0-2.941 1.1c-.757.652-1.153 1.438-1.153 2.055v.448l-.445.049C2.064 4.805 1 5.952 1 7.318 1 8.785 2.23 10 3.781 10H6a.5.5 0 0 1 0 1H3.781C1.708 11 0 9.366 0 7.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/><path fill-rule="evenodd" d="M7.646 4.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V14.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3z"/></svg>');
        background-repeat: no-repeat;
        background-size: 2rem 2rem;
        background-color: transparent;
        border: none;
        top: 30px;
        right: 50%;
        transform: translateX(50%);
        padding: 0.375rem 1rem;
      }
    }
  }
  .is-invalid .custom-file-label {
    border-color: #dc3545;
    padding-right: calc(1.5em + 0.75rem);
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right calc(0.375em + 0.1875rem) center;
    background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
  }
  .image-preview {
    text-align: center;
    img {
      width: 80%;
    }
  }
}
</style>

<script>
import { apiImage } from "@/assets/api/manage.js";
import { Toast } from "@/plugins/sweetalert2.js";

export default {
  name: "ImagePreview",
  props: [
    "state",
    "group_class",
    "image",
    "readonly",
    "multiple",
    "quantity",
    "required",
    "token"
  ],
  data() {
    return {
      dynamicId: Math.random(),
      imageFile: null,
      imageUrl: this.image,
      imageOnerror: "/img/image_onerror.jpg",
      imageQuantity: this.quantity
    };
  },
  watch: {
    image(data) {
      this.imageUrl = data;
    },
    imageFile(data) {
      if (!data) return;
      if (this.multiple) {
        this.imageQuantity = this.quantity;
        if (!this.imageUrl) {
          this.imageUrl = [];
        } else {
          this.imageQuantity -= this.imageUrl.length;
        }
        data.forEach(val => {
          if (this.imageQuantity === 0) return;
          this.imageQuantity -= 1;
          const reader = new FileReader();
          if (val) {
            reader.readAsDataURL(val);
          }
          reader.addEventListener("load", () => {
            var base64Str = reader.result;
            apiImage({ base64_image: base64Str, name: val.name }, this.token)
              .then(res => {
                if (res.status <= 201) {
                  this.imageUrl.push(res.data.path);
                  this.imageFile = null;
                  this.$emit("childMethod", this.imageUrl);
                } else {
                  Toast.fire({
                    icon: "error",
                    title: "圖片上傳失敗",
                    text: res.data.error
                  });
                }
              })
              .catch(err => {
                console.error(err);
              });
          });
        });
      } else {
        const reader = new FileReader();
        if (data) {
          reader.readAsDataURL(data);
        }
        reader.addEventListener("load", () => {
          var base64Str = reader.result;
          apiImage({ base64_image: base64Str, name: data.name }, this.token)
            .then(res => {
              if (res.status <= 201) {
                this.imageUrl = res.data.path;
                this.$emit("childMethod", this.imageUrl);
              } else {
                Toast.fire({
                  icon: "error",
                  title: "圖片上傳失敗",
                  text: res.data.error
                });
              }
            })
            .catch(err => {
              console.error(err);
            });
        });
      }
    }
  },
  methods: {
    getAllImgUrl(url) {
      return (process.env.VUE_APP_API_BASE_URL || "") + url;
    },
    removeImage(index) {
      if (this.multiple) {
        this.imageUrl.splice(index, 1);
        if (this.imageUrl.length === 0) {
          this.imageUrl = null;
        }
      } else {
        this.imageUrl = null;
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      var imgList = document.querySelectorAll(".image-preview > img");
      Array.prototype.forEach.call(imgList, item => {
        item.onerror = () => {
          item.src = this.imageOnerror;
        };
      });
    });
  }
};
</script>
